import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { ArrowLeft, Loader2 } from 'lucide-react'
import PostCard from '@/components/feed/PostCard'
import { feedService } from '@/services/feedService'
import type { IPost } from '@/types/feed'

const PostDetailPage: React.FC = () => {
  const { postId } = useParams<{ postId: string }>()
  const navigate = useNavigate()
  const [post, setPost] = useState<IPost | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!postId) return
    setLoading(true)
    setError(null)
    feedService
      .getPost(postId)
      .then((p) => setPost(p))
      .catch((err: unknown) => {
        setError(err instanceof Error ? err.message : 'Failed to load post')
      })
      .finally(() => setLoading(false))
  }, [postId])

  return (
    <div className="mx-auto max-w-2xl px-4 py-6">
      <Link to="/feed" className="mb-3 inline-flex items-center gap-1 text-sm text-gray-500 hover:text-gray-700">
        <ArrowLeft className="h-4 w-4" />
        Back to feed
      </Link>

      {loading && (
        <div className="flex items-center justify-center py-10 text-gray-400">
          <Loader2 className="h-6 w-6 animate-spin" />
        </div>
      )}

      {error && (
        <div className="rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
          {error}
        </div>
      )}

      {post && (
        <PostCard
          post={post}
          expandComments
          onDeleted={() => navigate('/feed')}
        />
      )}
    </div>
  )
}

export default PostDetailPage
